<!--任务信息-->
<template>
  <el-card shadow="hover" style="margin-bottom: 10px">
    <h3>任务信息</h3>
    <div class="warp" style="width: 500px;padding: 20px 50px 0">
      <page-form
        :ref-obj.sync="formInfo.ref"
        permission="assignmentManageAdd"
        :data="formInfo.data"
        :fileList="formFieldList"
        :labelWidth="formInfo.labelWidth"
        :ruleList="formInfo.rules"
        :submit="submitConfig"
      >
        <template v-slot:form-loading>
          <el-radio-group v-model="formInfo.data.loading">
            <el-radio label="1">需要</el-radio>
            <el-radio label="0">不需要</el-radio>
          </el-radio-group>
        </template>
        <template v-slot:form-note>
            <el-input type="textarea" autosize maxlength="80" v-model="formInfo.data.note" placeholder="请输入少于80个字"></el-input>
        </template>
      </page-form>
    </div>
  </el-card>
</template>

<script>
import pageForm from '@/components/Form/Index'
import goodsManage from '@/store/goodsManage/index.js'
import { SUPPLIERGETLISTS } from '@/store/goodsManage/types.js'
import {GETALLPOINT} from '@/store/assignmentManage/types'
import assignmentManage from '@/store/assignmentManage/index.js'
export default {
  props: ['formInfo', 'nature', 'warehouseCode'],
  components: { pageForm },
  data () {
    return {}
  },
  mounted () {
    this.getSelect()
  },
  methods: {
    submitConfig () {},
    // 获取下拉列表
    getSelect () {
      let params = {
        warehouseCode: this.$route.params.warehouseCode
      }
      this.$store.dispatch(GETALLPOINT, params)
      // 获取下拉框 - 供应商、配送仓点
      this.$store.dispatch(SUPPLIERGETLISTS, params)
    }
  },
  computed: {
    // 表单验证
    formFieldList () {
      let list = []
      if (this.formInfo.data.type === 'TASK_TYPE_ARRIVE' || this.formInfo.data.type === 'TASK_TYPE_EMPTY' || this.formInfo.data.type === 'TASK_TYPE_OTHER_OUT' || this.formInfo.data.type === 'TASK_TYPE_OTHER_PUT') {
        list = [
          {label: '供应商名称', prop: 'supplierCode', type: 'select', required: true, options: this.supplierSelect},
          {label: '任务类型', prop: 'type', type: 'select', required: true, options: this.goodsManageSelect},
          {label: '装卸服务', prop: 'loading', type: 'slot'},
          {label: '备注', prop: 'note', type: 'slot'}
        ]
      } else {
        list = [
          {label: '供应商名称', prop: 'supplierCode', type: 'select', required: true, options: this.supplierSelect},
          {label: '任务类型', prop: 'type', type: 'select', required: true, options: this.goodsManageSelect},
          {label: '配送仓点', prop: 'ydppCode', type: 'select', required: true, options: this.pointList},
          {label: '备注', prop: 'note', type: 'slot'}
        ]
      }
      // if (this.nature === '2') {
      // list.push({label: '备注', prop: 'note', type: 'slot'})
      // }
      return list
    },
    // 任务类型 - 下拉框
    goodsManageSelect () {
      let list = {
        // 出库
        1: [{ value: 'TASK_TYPE_SEND', name: '出货' },
          { value: 'TASK_TYPE_CPFR', name: '补货' },
          { value: 'TASK_TYPE_EMPTY', name: '退场' },
          { value: 'TASK_TYPE_OTHER_OUT', name: '其他出库' } ],
        // 入库
        2: [
          { value: 'TASK_TYPE_ARRIVE', name: '到货' },
          { value: 'TASK_TYPE_REMAINING', name: '多余退货' },
          { value: 'TASK_TYPE_AFTER', name: '售后退货' },
          { value: 'TASK_TYPE_OTHER_PUT', name: '其他入库' } ]
      }
      return list[this.nature]
    },
    // 供应商名称 - 下拉框
    supplierSelect () {
      return goodsManage.state.supplierSelect
    },
    // 配送仓点 - 下拉框
    pointList () {
      return assignmentManage.state.pointList.map(item => {
        return {value: item.ydppCode, name: item.ydppName}
      })
    }
  },
  watch: {
    'formInfo.data.type': {
      deep: true,
      handler (val) {
        this.formInfo.data.loading = ''
        this.formInfo.data.ydppCode = ''
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/page/assignmentManage/components/addTaskInfo.vue